import { Language } from '@/utils/language';

export type Author = {
  id: string;
  type: 'author';
  name: string;
  image?: object;
  position?: string;
  bio?: string;
  slug: string;
  language: Language;
}